'use strict';

function OnlineLogitCalibrationCSVService(gridExportCSVService) {
  var columnsHeaderMapToExport = {
    market: 'market',
    classSetId: 'productGroup',
    dayOfWeekShort: 'dayOfWeek',
    rtpBucket: 'rtpBucket',
    attribute: 'attribute',
    attributeValue: 'attributeValue',
    modelShare: 'modelValue',
    userShare: 'userValue',
    effectiveShare: 'effectiveValue'
  };
  function exportToCSV(rows) {
    return gridExportCSVService.exportToCSV(rows, columnsHeaderMapToExport, 'DemandShareExtract.csv');
  }
  return {
    exportToCSV: exportToCSV
  };
}
OnlineLogitCalibrationCSVService.$inject = ['GridExportCSVService'];
module.exports = OnlineLogitCalibrationCSVService;